// Only organizations using box layout can use home "cover"
export const organizationsWithCover = [
   'banff-pipeline-workshop'
]

export default {
   // Global
   tmpGlobalLayout: 'box',
   layoutContentFillMode: 'fluid',
   titlebarLgHeight: '85px[a-c] 100px[d] 110px[e-f]',
   tmpAppInnerPaddingHorizontal: '20px[a-b] 40px[c] 30px[d] 40px[e-f]',
   tmpAppOuterPaddingHorizontal: '20px[a-b] 40px[c] 30px[d] 50px[e-f]',
   tmpHeaderHeight: '60px[a-b] 80px[c] 75px[d] 75px[e-f]',
   tmpHeadingBlockHeight: '90px',
   tmpTitleXlLetterSpacing: '-0.5px[a-d] -0.75px[e-f]',
   tmpTitleXlLineHeight: '120%[a-d] 120%[e-f]',
   tmpTitleXlSize: '9[a-b] 10[c-d] 10[e-f]',
   tmpTitleLgSize: '7[a-b] 8[c-d] 9[e-f]',
   tmpTitleMdSize: '6',
   // Button
   tmpPrimaryButtonTextSize: '1.5[a-d] 2.5[d] 3.5[e-f]',
   tmpSecondaryButtonTextSize: '1.5[a-d] 2[e-f]',
   tmpPrimaryButtonHeight: '35px[a-c] 44px[d] 48px[e-f]',
   tmpSecondaryButtonHeight: '35px[a-c] 44px[d] 48px[e-f]',
   // Spacing
   tmpSpacing: '25px[a-d] 30px[e] 40px[f]',
   tmpSpacingTop: '25px[a-b] 30px[c-d] 40px[e-f]',
   // Viewport Constants
   tmpViewportHeight: `
      calc(100vh - 60px)[a-b]
      calc(100vh - 80px)[c]
      calc(100vh - 0px)[d-f]
   `,
   tmpContentFixedAreaHeight: `
      calc(100vh - 60px)[a-b]
      calc(100vh - 80px)[c]
      calc(100vh - 0px)[d-f]
   `,
   viewportMarginTop: '0px',
   tmpViewportPadding: '20px[a] 20px[b] 40px[c] 0px[d] calc(50vw - 900px + 150px)[e] calc(50vw - 900px + 150px)[f]',
   tmpViewportPaddingA: '20px',
   tmpViewportPaddingB: '20px',
   tmpViewportPaddingC: '40px',
   tmpViewportPaddingD: '0px',
   tmpViewportPaddingE: 'calc(50vw - 900px + 150px)',
   tmpViewportPaddingF: 'calc(50vw - 900px + 150px)'
}
